import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/home',
            name: 'admin-home',
            component: () => import(/* webpackChunkName: "page-admin-default-home" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "主页"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "主页"
                            }
                        ]
                    }
                }
            },

        },
    ],
    meta: {
        data_for_get_routes_by_require: {
            enable: true,
        },
    }
};
